import { render, staticRenderFns } from "./GuidedRegulationsReviewSection.vue?vue&type=template&id=c5a4fef4&scoped=true&"
import script from "./GuidedRegulationsReviewSection.vue?vue&type=script&lang=js&"
export * from "./GuidedRegulationsReviewSection.vue?vue&type=script&lang=js&"
import style0 from "./GuidedRegulationsReviewSection.vue?vue&type=style&index=0&id=c5a4fef4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a4fef4",
  null
  
)

export default component.exports